import { useParams, useSearchParams } from 'react-router-dom'
import Button from '@hotmart/space-lib/dist/components/button'
import { useListCommunities } from 'src/hook/useListCommunities'
import { useMemo } from 'react'
import { Loading } from 'src/components'
import { NoSearchResults } from 'src/components/noSearchResults'
import i18n from 'src/i18n'
import { COMMUNITIES_PER_PAGE } from './communityHome.constants'
import { PathParams } from './communityHome.types'
import { CommunityCard, EmptyState } from './components'

const CommunityHome = () => {
  const { membership } = useParams() as PathParams
  const [searchParams] = useSearchParams()
  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useListCommunities({
    membership,
    communitiesPerPage: COMMUNITIES_PER_PAGE
  })

  const communities = useMemo(() => {
    return data?.pages.flatMap((page) => page.data)
  }, [data])

  const hasSearchParam = searchParams.get('q')
  const isValidCommunitiesList = Array.isArray(communities) && communities.length > 0
  const myCommunityList = communities?.filter((community) => community.isOwnerOrFollower) || []
  const showNoSearchResultsComponent =
    hasSearchParam && isValidCommunitiesList && myCommunityList.length

  const handleLoadMoreComments = () => {
    const pages = data?.pages
    const lastPage = pages?.[pages.length - 1]
    const nextPageToken = lastPage?.nextPageToken || ''

    fetchNextPage({ pageParam: nextPageToken })
  }

  if (isLoading) {
    return <Loading full />
  }

  if (showNoSearchResultsComponent) {
    return <NoSearchResults communities={myCommunityList} />
  }

  if (hasSearchParam) {
    return (
      <EmptyState title="modal_empty_generic.title" description="modal_empty_generic.description" />
    )
  }

  return (
    <div className="_py-5">
      <div className="_d-md-flex _justify-content-between _mb-5 _align-items-center">
        <div className="_w-full _d-flex _justify-content-between _align-items-center">
          <h2 className="_text-3 _font-weight-bold _mb-0">{i18n.t('title')}</h2>
        </div>
      </div>

      <div className="_w-full _h-full _overflow-x-hidden _overflow-y-hidden">
        {isValidCommunitiesList ? (
          communities?.map((community) => (
            <CommunityCard key={community.id} community={community} />
          ))
        ) : (
          <EmptyState title="is_no_community.title" description="is_no_community.description" />
        )}
      </div>

      {hasNextPage && (
        <div className="_d-flex _justify-content-center _mt-6">
          <Button
            variation="primary"
            disabled={isFetchingNextPage}
            loading={isFetchingNextPage}
            onClick={handleLoadMoreComments}
          >
            {i18n.t('buttons.show_more')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default CommunityHome
